var map = {
	"./Area": [
		9945,
		945
	],
	"./Area.js": [
		9945,
		945
	],
	"./Bar": [
		61255,
		255
	],
	"./Bar.js": [
		61255,
		255
	],
	"./Boxplot": [
		11787,
		524
	],
	"./Boxplot.js": [
		11787,
		524
	],
	"./Bubble": [
		15662,
		662
	],
	"./Bubble.js": [
		15662,
		662
	],
	"./BubbleMap": [
		46142,
		142
	],
	"./BubbleMap.js": [
		46142,
		142
	],
	"./Candlestick": [
		88896,
		896
	],
	"./Candlestick.js": [
		88896,
		896
	],
	"./Categories": [
		64965,
		965
	],
	"./Categories.js": [
		64965,
		965
	],
	"./Choropleth": [
		95815,
		815
	],
	"./Choropleth.js": [
		95815,
		815
	],
	"./Column": [
		85460,
		460
	],
	"./Column.js": [
		85460,
		460
	],
	"./DependencyWheel": [
		38463,
		463
	],
	"./DependencyWheel.js": [
		38463,
		463
	],
	"./Donut": [
		40341,
		341
	],
	"./Donut.js": [
		40341,
		341
	],
	"./Dumbbell": [
		63265,
		265
	],
	"./Dumbbell.js": [
		63265,
		265
	],
	"./Funnel": [
		3654,
		654
	],
	"./Funnel.js": [
		3654,
		654
	],
	"./Heatmap": [
		92060,
		60
	],
	"./Heatmap.js": [
		92060,
		60
	],
	"./Honeycomb": [
		68585,
		585
	],
	"./Honeycomb.js": [
		68585,
		585
	],
	"./Line": [
		4582,
		582
	],
	"./Line.js": [
		4582,
		582
	],
	"./OHLC": [
		84701,
		701
	],
	"./OHLC.js": [
		84701,
		701
	],
	"./PackedBubble": [
		33130,
		95
	],
	"./PackedBubble.js": [
		33130,
		95
	],
	"./Parliament": [
		2251,
		251
	],
	"./Parliament.js": [
		2251,
		251
	],
	"./PatternFill": [
		6078,
		78
	],
	"./PatternFill.js": [
		6078,
		78
	],
	"./Pie": [
		77999,
		999
	],
	"./Pie.js": [
		77999,
		999
	],
	"./PointMap": [
		93740,
		740
	],
	"./PointMap.js": [
		93740,
		740
	],
	"./PolarArea": [
		36499,
		499
	],
	"./PolarArea.js": [
		36499,
		499
	],
	"./RadialBar": [
		38527,
		527
	],
	"./RadialBar.js": [
		38527,
		527
	],
	"./Sankey": [
		90276,
		276
	],
	"./Sankey.js": [
		90276,
		276
	],
	"./Scatter": [
		94653,
		653
	],
	"./Scatter.js": [
		94653,
		653
	],
	"./SolidGauge": [
		34876,
		876
	],
	"./SolidGauge.js": [
		34876,
		876
	],
	"./SpiderArea": [
		46735,
		735
	],
	"./SpiderArea.js": [
		46735,
		735
	],
	"./StackedArea": [
		45196,
		196
	],
	"./StackedArea.js": [
		45196,
		196
	],
	"./StackedBar": [
		57346,
		346
	],
	"./StackedBar.js": [
		57346,
		346
	],
	"./StackedColumn": [
		50430,
		430
	],
	"./StackedColumn.js": [
		50430,
		430
	],
	"./StreamGraph": [
		49208,
		208
	],
	"./StreamGraph.js": [
		49208,
		208
	],
	"./TilemapCircle": [
		71715,
		715
	],
	"./TilemapCircle.js": [
		71715,
		715
	],
	"./Timeline": [
		84494,
		494
	],
	"./Timeline.js": [
		84494,
		494
	],
	"./Treemap": [
		5422,
		422
	],
	"./Treemap.js": [
		5422,
		422
	],
	"./Unit": [
		51204,
		204
	],
	"./Unit.js": [
		51204,
		204
	],
	"./Waterfall": [
		15146,
		146
	],
	"./Waterfall.js": [
		15146,
		146
	],
	"./WindRose": [
		59518,
		518
	],
	"./WindRose.js": [
		59518,
		518
	],
	"./WordCloud": [
		17846,
		846
	],
	"./WordCloud.js": [
		17846,
		846
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 90018;
module.exports = webpackAsyncContext;